function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Path } from "react-native-svg";

function SvgMedalLoFi(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(Path, {
    d: "M1.125 20.415l2.138-4.84c.351.452 1.693 1.453 4.247 1.835l-2.138 4.84-1.487-2.36-2.76.525zM16.31 20.415l-2.139-4.84c-.351.452-1.693 1.453-4.247 1.835l2.138 4.84 1.487-2.36 2.76.525z",
    fill: props.color
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M17.469 8.9c0 4.616-3.786 8.369-8.469 8.369S.531 13.516.531 8.9 4.317.531 9 .531s8.469 3.753 8.469 8.369z",
    fill: props.color,
    stroke: props.colorSecondary,
    strokeWidth: 1.063
  }));
}

export default SvgMedalLoFi;